export enum Fieldtype {
    FLAMINGO = 'flamingo',
    WALL = 'wall',
    GRAVE = 'grave',
    CONTRACT = 'contract',
    FLAMINGO_GRAVE = 'flamingo-grave',
    GRAVE_DONE = 'grave-done',
    EMPTY = 'empty',
}
